<template>
  <li
    :class="[
      $style.container,
      { [$style.live]: activityHasStarted },
      { [$style.hasProgressBar]: hasProgressBar },
    ]"
  >
    <!-- Avatar -->
    <div :class="$style.avatar">
      <img
        v-if="activity.organizer.photoUrl"
        :src="activity.organizer.photoUrl"
      />
    </div>
    <!-- Activity details -->
    <div :class="$style.content">
      <p :class="$style.organizerName">{{ activity.organizer.name }}</p>
      <p :class="$style.activityTitle">{{ activity.title }}</p>
      <p v-if="duration" :class="$style.duration">
        <font-awesome-icon :icon="faClock" /> {{ duration }}
      </p>
    </div>

    <template v-if="activityHasStarted">
      <!-- Live Streaming Join Button -->
      <a
        v-if="showLiveStreamJoinBtn"
        :href="liveStreamUrl"
        :target="targetWindow"
        :class="$style.join"
      >
        <div
          v-if="hasProgressBar"
          ref="progressBar"
          :class="$style.progress"
        ></div>
        <font-awesome-icon :icon="faVideo" :class="$style.icon" />
        <span :class="$style.label">Join</span>
      </a>
      <!-- Phone call Join button -->
      <button
        v-else-if="this.isSoftphone"
        @click="openExtension"
        :class="$style.join"
      >
        <div
          v-if="hasProgressBar"
          ref="progressBar"
          :class="$style.progress"
        ></div>
        <font-awesome-icon v-bind="iconProps" :class="$style.icon" />
        <span :class="$style.label">Join</span>
      </button>
    </template>
    <span v-else :class="$style.join">
      <font-awesome-icon v-bind="iconProps" :class="$style.icon" />
    </span>
  </li>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faClock } from "@fortawesome/pro-light-svg-icons/faClock";
import { faPhone } from "@fortawesome/pro-light-svg-icons/faPhone";
import { faVideo } from "@fortawesome/pro-light-svg-icons/faVideo";
import moment from "moment";
import ProgressBar from "progressbar.js";
import formatDuration from "vue-components/utils/format-duration";
import window, { chrome, sessionStorage } from "window";

export default {
  components: {
    FontAwesomeIcon,
  },
  props: ["activity"],
  data() {
    return {
      faClock,
      faVideo,
      team: this.$_liveCoach_config.getTeam(),
    };
  },
  computed: {
    liveStreamUrl() {
      return `${this.$_liveCoach_config.jiminnyHost()}/live/${
        this.activity.id
      }`;
    },
    targetWindow() {
      return this.$_liveCoach_config.hostApp === "extension-app"
        ? "_blank"
        : "_self";
    },
    isSoftphone() {
      return (
        this.activity.type === "softphone" ||
        this.activity.type === "softphone-inbound"
      );
    },
    isConference() {
      return this.activity.type === "conference";
    },
    iconProps() {
      return this.isConference
        ? { icon: faVideo }
        : { icon: faPhone, flip: "horizontal" };
    },
    activityHasStarted() {
      return !!this.activity.actualStartTime;
    },
    scheduledDuration() {
      const { scheduledStartTime, scheduledEndTime } = this.activity;
      if (scheduledStartTime && scheduledEndTime) {
        return moment
          .utc(scheduledEndTime)
          .diff(moment.utc(scheduledStartTime));
      }
      return null;
    },
    duration() {
      if (this.activityHasStarted) {
        return this.elapsedDuration;
      } else if (this.scheduledStartTime) {
        return this.scheduledStartTime;
      } else {
        return null;
      }
    },
    elapsedDuration() {
      const now = moment.utc();
      const start = moment.utc(this.activity.actualStartTime);
      const elapsed = now.diff(start);
      return formatDuration(elapsed, { hours: "visible", seconds: "none" });
    },
    scheduledStartTime() {
      const { scheduledStartTime } = this.activity;

      if (scheduledStartTime) {
        return moment.utc(scheduledStartTime).local().format("MMM Do, h:mm A");
      }

      return null;
    },
    hasProgressBar() {
      return this.activityHasStarted && this.scheduledDuration;
    },
    hasLiveStreamFeature() {
      return !!this.team.features.find(
        (feature) => feature.name === "VIDEOCOACH"
      );
    },
    isPreparingLiveStream() {
      return this.activity?.onAir === 1 || this.activity?.onAir === 2;
    },
    isLiveStreaming() {
      return this.activity?.onAir === 3;
    },
    showLiveStreamJoinBtn() {
      return (
        this.hasLiveStreamFeature &&
        (this.isLiveStreaming || this.isPreparingLiveStream)
      );
    },
  },
  mounted() {
    this.initProgressBar();
  },
  methods: {
    initProgressBar() {
      const container = this.$refs.progressBar;

      if (!container) {
        return;
      }

      container.innerHTML = "";
      const circle = new ProgressBar.Circle(container, {
        color: "#f0415a",
        strokeWidth: 3,
        trailColor: "#656675",
        trailWidth: 2,
        duration: 800,
        easing: "easeInOut",
      });

      const start = moment.utc(this.activity.actualStartTime);
      const elapsedDuration = moment.utc().diff(start);
      const ratio = elapsedDuration / this.scheduledDuration;
      const progress = Math.min(1, ratio);
      circle.animate(progress);
    },
    openExtension() {
      if (this.$_liveCoach_config.hostApp === "app") {
        chrome.runtime.sendMessage(this.$_liveCoach_config.extensionId, {
          type: "JIMINNY.EXTENSION.COACH_SOFTPHONE_ACTIVITY",
          activityId: this.activity.id,
        });
      } else {
        window.location.hash = `phone-controller?type=LIVE_COACH&activityId=${this.activity.id}`;
      }
    },
  },
  watch: {
    activity() {
      this.initProgressBar();
    },
  },
};
</script>

<style module lang="less" src="./activity.less"></style>



// WEBPACK FOOTER //
// activity.vue?43b4ec62